<template lang="pug">
.searchComponent
  input.input(
    ref="input"
    type="text"
    placeholder="Поиск по названию"
    @input="onInput"
    :value="modelValue"
  )
  .search-wrap
    ui-svg-icon(name="search")
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  data () {
    return {
      timer: 2000,
      interval: null,
      hasChanges: false
    }
  },
  created () {
    this.interval = setInterval(this.updateTimer, 100)
  },
  beforeUnmount () {
    clearInterval(this.interval)
  },
  methods: {
    updateTimer () {
      if (this.hasChanges) {
        if (this.timer > 0) this.timer -= 100
        else {
          this.$emit('update:modelValue', this.$refs.input.value)
          this.hasChanges = false
        }
      }
    },
    onInput () {
      this.hasChanges = true
      this.timer = 500
    }
  }
}
</script>

<style lang="sass" scoped>
.searchComponent
  display: grid
  max-width: 75*$u
  width: 100%
  height: 11*$u
  position: relative
  .input
    padding-left: 9.5*$u
    color: $cBlack
    background: $cWhite
    border-radius: 2.5*$u
    border: none
    @include font('t14-regular')
    &::placeholder
      color: $cDarkGrey
  .search-wrap
    position: absolute
    left: 3.5*$u
    top: 3.5*$u
    width: 4*$u
    height: 4*$u
    color: $cDarkGrey
</style>
